<app-data-table mainTitle="Tipos de Registro"
                singleTitle="Tipo de Registro"
                routerPath="/siscoserv/tipo-registro"
                entityPath="/tbreg"
                [entity]="tbReg"
                [columns]="this['columns']"
                [controls]="this['controls']">
</app-data-table>
